<!-- Full component -->
<div class="app-container">
  <!-- Main Sidebar - Icons Only -->
  <div class="sidebar icons-only">
    <div class="sidebar-content">
      <!-- Logo in Sidebar -->
      <a class="sidebar-logo"
        [routerLink]="currentUserRole=='LEAD' ? ['/portal/notification']:['/leads/leads-managment']">
        <img src="../../../assets/images/logos/dostify-logo.svg" alt="Logo" height="50" width="50">
      </a>

      <!-- Display all sections including reports -->
      <ng-container *ngFor="let item of getMainNavItems()">
        <!-- Section Headers - Only show if we have dividers between sections -->
        <div *ngIf="item.navCap && hasAccess(item.roleStrict)" class="sidebar-section-divider"></div>

        <!-- Menu Items (not headers) -->
        <ng-container *ngIf="!item.navCap && hasAccess(item.roleStrict)">
          <!-- Simple menu item - Icon Only with Badge for Engagement Hub -->
          <a class="sidebar-item" [routerLink]="item.route" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}" [class.active]="isRouteActive(item.route)"
            [class.has-new-items]="hasNewEngagementItems && item.route === '/admissions/engagment-hub'" matRipple
            [matTooltip]="getItemTooltip(item)" matTooltipPosition="right">
            <div class="sidebar-icon-container">
              <mat-icon [matBadge]="getEngagementHubBadge(item)" [matBadgeHidden]="!shouldShowEngagementBadge(item)"
                matBadgeColor="warn" matBadgeSize="small">
                {{ item.iconName }}
              </mat-icon>
            </div>
          </a>
        </ng-container>
      </ng-container>

      <!-- Admin Access Button -->
      <a *ngIf="hasAccess(['ADMIN', 'USER'])" class="sidebar-item admin-toggle" (click)="toggleAdminSidebar()" matRipple
        matTooltip="Admin Panel" matTooltipPosition="right" style="cursor: pointer;">
        <div class="sidebar-icon-container">
          <mat-icon>admin_panel_settings</mat-icon>
        </div>
      </a>
    </div>
  </div>

  <div class="main-content-wrapper">
    <!-- Top Header Bar with Centered Search -->
    <mat-toolbar class="header-toolbar">
      <!-- Left Section -->
      <div class="toolbar-section toolbar-left">
        <mat-icon style="cursor: pointer;">auto_awesome</mat-icon>
        <div style="font-size: 16px; margin-left: 10px;">{{ getActiveNavItem() }}</div>
      </div>

      <!-- Center Section with Search -->
      <div class="toolbar-section toolbar-center">
        <app-global-search></app-global-search>
      </div>

      <!-- Right Section -->
      <div class="toolbar-section toolbar-right">
        <!-- Action Status Bar -->
        <div class="action-status-bar" *ngIf="hasAccess(['ADMIN', 'USER'])">
          <div class="status-chip" [class.ready]="userActionService.todoStatus() === 'NOW'"
            [class.planned]="userActionService.todoStatus() === 'TODAY'"
            [class.complete]="userActionService.todoStatus() === 'CLEAR'" (click)="openUserActions()"
            [matTooltip]="getActionTooltip()">
            <mat-icon class="desktop-only">{{getMinimalIcon()}}</mat-icon>
            <span class="desktop-only">{{getMinimalText()}}</span>
            <span class="mobile-only">{{getActionCount()}}</span>
          </div>
        </div>

        <button *ngIf="hasAccess(['ADMIN', 'USER'])" mat-icon-button class="goals-btn" (click)="openMyGoals()"
          matTooltip="My Goals">
          <mat-icon>emoji_objects</mat-icon>
        </button>

        <button *ngIf="hasAccess(['ADMIN', 'USER'])" mat-icon-button class="help-btn" (click)="openHelpCenter()"
          matTooltip="Help Center">
          <mat-icon>help_outline</mat-icon>
        </button>

        <!-- Inbox button -->
        <button *ngIf="hasAccess(['ADMIN', 'USER'])" mat-icon-button
        class="notification-btn" (click)="goToInbox()">
        <mat-icon [matBadge]="formatBadgeCount(notificationService.inbox_count())"
          [matBadgeHidden]="notificationService.inbox_count() === 0" matBadgeColor="warn">
          mail_outline
        </mat-icon>
      </button>

        <!-- Notification button -->
        <button *ngIf="hasAccess(['ADMIN', 'USER'])" mat-icon-button [matMenuTriggerFor]="myMenu"
          class="notification-btn" (click)="$event.stopPropagation(); openNotifications()">
          <mat-icon [matBadge]="formatBadgeCount(notificationService.notification_count())"
            [matBadgeHidden]="notificationService.notification_count() === 0" matBadgeColor="warn">
            notifications_none
          </mat-icon>
        </button>

        <!-- User Profile Menu -->
        <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="profile-button">
          <img [src]="pathImage" alt="Profile" class="profile-avatar">
        </button>
      </div>

      <!-- Notification Menu -->
      <mat-menu #myMenu="matMenu" class="my-menu">
        <div class="notification-header" (click)="$event.stopPropagation()">
          <h3 class="notification-title">Notifications</h3>
          <span>
            <span class="badge-primary">{{formatBadgeCount(notificationService.notification_count())}} new</span>
          </span>
        </div>

        <!-- Tab Navigation for All/Unseen with Clear All -->
        <div class="notification-tabs" (click)="$event.stopPropagation()">
          <div class="tabs-left">
            <span class="notification-tab" [class.active]="currentTab === 'all'" (click)="setTab($event, 'all')">
              All
            </span>
            <span class="notification-tab" [class.active]="currentTab === 'unread'" (click)="setTab($event, 'unread')">
              Unseen
            </span>
          </div>
          <span class="clear-all-link" (click)="clearAllNotifications($event)">
            Clear all
          </span>
        </div>

        <mat-divider></mat-divider>

        <!-- Notification list with scroll -->
        <div class="notification-list" (scroll)="onScroll($event)">
          <div *ngFor="let notification of notifications" class="notification-item" [class.unread]="!notification.seen"
            (click)="openNotification($event, notification)">
            <i-tabler name="{{ notification.icon || 'help'}}" class="icon-25 d-flex"></i-tabler>
            <div class="notification-content">
              <div class="notification-header-row">
                <h4>{{ notification.title }}</h4>
                <span *ngIf="!notification.seen" class="unread-indicator"></span>
              </div>
              <p class="notification-body">{{ notification.subtitle }}</p>
              <span class="notification-time">{{ notification.time | date:'short' }}</span>
            </div>
          </div>

          <div *ngIf="notifications.length === 0" class="notification-empty">
            <p>No notifications</p>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="notification-footer">
          <button mat-button color="primary" (click)="showAllNotifications()">
            See all notifications
          </button>
        </div>
      </mat-menu>

      <!-- User Profile Menu -->
      <mat-menu #profileMenu="matMenu" class="proflie-menu">
        <div class="profile-menu-header">
          <img [src]="pathImage" alt="Profile" class="profile-menu-avatar">
          <div class="profile-menu-info">
            <h3>{{ userName }}</h3>
            <p>{{ currentUserRole }}</p>
          </div>
        </div>
        <mat-divider></mat-divider>

        <!-- Dynamic Profile Links -->
        <ng-container *ngFor="let item of profile">
          <button mat-menu-item *ngIf="hasAccess(item.roles)" [routerLink]="item.link">
            <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span>{{ item.title }}</span>
          </button>
        </ng-container>

        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <div class="main-container">
      <!-- Admin Sidebar (Second Sidebar) - Also Icons Only -->
      <div class="admin-sidebar icons-only" [class.expanded]="isAdminExpanded">
        <div class="sidebar-content">
          <div class="admin-sidebar-header">
            <button mat-icon-button (click)="toggleAdminSidebar()" class="close-admin-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- Get the Admin Config item -->
          <ng-container *ngFor="let item of getAdminNavItems()">
            <div *ngIf="hasChildren(item)" class="sidebar-item-group">
              <!-- Children items -->
              <div class="admin-sidebar-items">
                <a *ngFor="let child of getVisibleChildren(item)" class="sidebar-item" [routerLink]="child.route"
                  [class.active]="isRouteActive(child.route)" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: false}" matRipple [matTooltip]="child.displayName"
                  matTooltipPosition="right">
                  <div class="sidebar-icon-container">
                    <mat-icon>{{ child.iconName }}</mat-icon>
                  </div>
                </a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Main Content -->
      <div class="content-area" [ngClass]="{'with-admin-sidebar': isAdminExpanded}">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>